import type { QuickDestination } from '../types'

// V0.1 원칙: 실기기에서 최종 검증되지 않은 좌표는 null로 유지한다.
// 운영 전 Google Places 후보를 현장에서 선택하고 Uber 앱의 핀 위치를 대조해야 한다.
export const quickDestinations: QuickDestination[] = [
  {
    id: 'haeundae',
    nameKo: '해운대',
    nameEn: 'Haeundae Beach',
    names: { ko: '해운대', en: 'Haeundae Beach', ja: '海雲台', 'zh-CN': '海云台', 'zh-TW': '海雲臺', id: 'Pantai Haeundae', vi: 'Bãi biển Haeundae', es: 'Playa de Haeundae', ar: 'شاطئ هايونداي', ru: 'Пляж Хэундэ', hi: 'हैउन्डे बीच' },
    address: '부산광역시 해운대구 해운대해변로 264',
    latitude: null,
    longitude: null,
    category: 'beach',
    coordinateStatus: 'NEEDS_VERIFICATION',
    verificationNote: '해운대 해수욕장 대표 승하차 지점을 실기기에서 확정해야 합니다.',
  },
  {
    id: 'gwangalli',
    nameKo: '광안리',
    nameEn: 'Gwangalli Beach',
    names: { ko: '광안리', en: 'Gwangalli Beach', ja: '広安里', 'zh-CN': '广安里', 'zh-TW': '廣安里', id: 'Pantai Gwangalli', vi: 'Bãi biển Gwangalli', es: 'Playa de Gwangalli', ar: 'شاطئ غوانغالي', ru: 'Пляж Кваналли', hi: 'ग्वांगल्ली बीच' },
    address: '부산광역시 수영구 광안해변로 일대',
    latitude: null,
    longitude: null,
    category: 'beach',
    coordinateStatus: 'NEEDS_VERIFICATION',
    verificationNote: '해변 구간이 넓어 대표 승하차 지점을 확정해야 합니다.',
  },
  {
    id: 'busan-cinema-center',
    nameKo: '영화의전당',
    nameEn: 'Busan Cinema Center',
    names: { ko: '영화의전당', en: 'Busan Cinema Center', ja: '釜山映画の殿堂', 'zh-CN': '釜山电影殿堂', 'zh-TW': '釜山電影殿堂', id: 'Pusat Sinema Busan', vi: 'Trung tâm Điện ảnh Busan', es: 'Centro de Cine de Busan', ar: 'مركز بوسان للسينما', ru: 'Киноцентр Пусана', hi: 'बुसान सिनेमा सेंटर' },
    address: '부산광역시 해운대구 수영강변대로 120',
    latitude: null,
    longitude: null,
    category: 'culture',
    coordinateStatus: 'NEEDS_VERIFICATION',
    verificationNote: '공식 출입구 기준 승하차 좌표를 확정해야 합니다.',
  },
  {
    id: 'pknu-daeyeon',
    nameKo: '부경대',
    nameEn: 'Pukyong National University, Daeyeon Campus',
    names: { ko: '부경대', en: 'Pukyong National University', ja: '釜慶大学校', 'zh-CN': '釜庆大学', 'zh-TW': '釜慶大學', id: 'Universitas Nasional Pukyong', vi: 'Đại học Quốc gia Pukyong', es: 'Universidad Nacional de Pukyong', ar: 'جامعة بوكيونغ الوطنية', ru: 'Национальный университет Пукён', hi: 'पुक्योंग राष्ट्रीय विश्वविद्यालय' },
    address: '부산광역시 남구 용소로 45 (대연캠퍼스)',
    latitude: null,
    longitude: null,
    category: 'university',
    coordinateStatus: 'NEEDS_VERIFICATION',
    verificationNote: '대연캠퍼스 정문 또는 택시 승하차 지점을 확정해야 합니다.',
  },
  {
    id: 'busan-north-port',
    nameKo: '부산북항',
    nameEn: 'Busan North Port',
    names: { ko: '부산북항', en: 'Busan North Port', ja: '釜山北港', 'zh-CN': '釜山北港', 'zh-TW': '釜山北港', id: 'Pelabuhan Utara Busan', vi: 'Cảng Bắc Busan', es: 'Puerto Norte de Busan', ar: 'ميناء بوسان الشمالي', ru: 'Северный порт Пусана', hi: 'बुसान उत्तरी बंदरगाह' },
    address: '부산광역시 동구·중구 부산항 북항 일대',
    latitude: null,
    longitude: null,
    category: 'port',
    coordinateStatus: 'NEEDS_VERIFICATION',
    verificationNote: '범위가 넓어 북항 친수공원 등 구체적인 목적지 합의가 필요합니다.',
  },
  {
    id: 'ilpum-hanwoo',
    nameKo: '일품한우',
    nameEn: 'Ilpum Hanwoo',
    names: { ko: '일품한우', en: 'Ilpum Hanwoo', ja: 'イルプム韓牛', 'zh-CN': '一品韩牛', 'zh-TW': '一品韓牛', id: 'Ilpum Hanwoo', vi: 'Ilpum Hanwoo', es: 'Ilpum Hanwoo', ar: 'إلبوم هانوو', ru: 'Ильпум Ханву', hi: 'इलपुम हानवू' },
    address: null,
    latitude: null,
    longitude: null,
    category: 'restaurant',
    coordinateStatus: 'NEEDS_VERIFICATION',
    verificationNote: '정확한 매장명과 주소 확인 전에는 좌표를 추가하지 않습니다.',
  },
]
